<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full">
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="标题">
            <a-input v-model="dataForm.title" placeholder="标题搜索" />
          </a-form-item>
          <a-form-item label="类型">
            <a-select v-model="dataForm.type" style="width: 120px;" placeholder="请选择类型">
              <a-select-option value="1">酒店</a-select-option>
              <a-select-option value="2">别墅</a-select-option>
              <a-select-option value="3">游艇</a-select-option>
              <a-select-option value="4">豪车</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增数据</a-button>
          </a-form-item>
        </a-form>

        <a-table :scroll="{ x: 1500 }" :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
          :loading="dataListLoading">
          <template slot="images" slot-scope="text, row">
            <a-tag :color="text.split(',').length > 0 ? 'green' : 'red'">{{ text ? (text.split(',').length + '张') : '0张'
            }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.indexid)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.indexid)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/appindex/page",
        deleteURL: "/admin/appindex/delete",
      },
      dataForm: {
        title: "",
        type: undefined
      },
      columns: [
        {
          title: "图片素材",
          dataIndex: "images",
          width: 100,
          scopedSlots: { customRender: "images" },
        },
        {
          title: "标题内容",
          dataIndex: "title",
          width: 200
        },
        {
          title: "副标题内容",
          dataIndex: "subtitle",
          width: 300,
          ellipsis: true
        },
        {
          title: "类型",
          dataIndex: "type_text",
          width: 200,
        },
        {
          title: "排序",
          dataIndex: "sort",
          width: 200
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>